import React from "react";
import { Aside } from "sprint-common-web";

import { DeliveryInfoAsideContent } from "./DeliveryInfoAsideContent";

export interface DeliveryInfoAsideProps {
    deliveryId: string;
    isOpen: boolean;
    onClose(): void;
}

export const DeliveryInfoAside: React.FunctionComponent<DeliveryInfoAsideProps> = (props: DeliveryInfoAsideProps) => {
    const { deliveryId, isOpen, onClose } = props;

    return (
        <Aside isOpen={isOpen} headerText="Delivery Info" type="readonly" onDismiss={onClose} isLightDismiss={true}>
            <DeliveryInfoAsideContent deliveryId={deliveryId} />
        </Aside>
    );
};
